(function () {
	const SCROLL_OFFSET = 60;

	function getItemsPerPage(group) {
		const value = parseInt(group.dataset.itemsPerPage, 10);
		return Number.isFinite(value) && value > 0 ? value : 4;
	}

	function scrollToTopicGroup(group) {
		const scrollTarget =
			group.querySelector(".us-collection-list-heading") ||
			group.querySelector(".section-header__title") ||
			group;
		const top =
			scrollTarget.getBoundingClientRect().top +
			window.scrollY -
			SCROLL_OFFSET;

		window.scrollTo({
			top: Math.max(0, top),
			behavior: "smooth",
		});
	}

	function initTopicGroup(group) {
		if (group.dataset.usTopicGroupInit === "true") return;
		group.dataset.usTopicGroupInit = "true";

		const items = Array.from(group.querySelectorAll("[data-us-topic-item]"));
		const pagination = group.querySelector("[data-us-topic-pagination]");
		const itemsPerPage = getItemsPerPage(group);
		if (!pagination || items.length <= itemsPerPage) return;

		const totalPages = Math.ceil(items.length / itemsPerPage);
		const prevBtn = pagination.querySelector("[data-us-topic-prev]");
		const nextBtn = pagination.querySelector("[data-us-topic-next]");
		const pageLabel = pagination.querySelector("[data-us-topic-page-label]");
		let currentPage = 1;

		function updatePageLabel() {
			if (!pageLabel) return;
			pageLabel.textContent = `Seite ${currentPage} - ${totalPages}`;
		}

		function showPage(page, shouldScroll) {
			const previousPage = currentPage;
			currentPage = Math.max(1, Math.min(page, totalPages));

			items.forEach((item, index) => {
				const itemPage = Math.floor(index / itemsPerPage) + 1;
				item.classList.toggle(
					"us-topic-group__item--hidden",
					itemPage !== currentPage,
				);
			});

			if (prevBtn) prevBtn.disabled = currentPage === 1;
			if (nextBtn) nextBtn.disabled = currentPage === totalPages;
			updatePageLabel();

			if (shouldScroll && currentPage !== previousPage) {
				scrollToTopicGroup(group);
			}
		}

		if (prevBtn) {
			prevBtn.addEventListener("click", () => showPage(currentPage - 1, true));
		}

		if (nextBtn) {
			nextBtn.addEventListener("click", () => showPage(currentPage + 1, true));
		}

		showPage(1, false);
	}

	function initTopicGroups(root) {
		const scope = root || document;
		scope.querySelectorAll("[data-us-topic-group]").forEach(initTopicGroup);
	}

	if (document.readyState === "loading") {
		document.addEventListener("DOMContentLoaded", () => initTopicGroups());
	} else {
		initTopicGroups();
	}

	document.addEventListener("shopify:section:load", (event) => {
		initTopicGroups(event.target);
	});
})();
